import React, { useState, useContext, useEffect, useRef, useMemo, useCallback } from "react";
import { Table, Form, Input, Button, Popconfirm, Space, Modal, notification, DatePicker, Progress, InputNumber, Select, Popover, Checkbox, Tooltip } from "antd";
import type { TableProps, InputRef, FormInstance, TableColumnsType, TableColumnType } from "antd";
import { ChassisDataType } from "../pages/service/modal_chassis_for_wo";
import dayjs from "dayjs";
import { LoadingOutlined, SearchOutlined, EyeInvisibleOutlined, SettingOutlined } from "@ant-design/icons";
import { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import useSWR from "swr";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { debounce, isEqual } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { Resizable } from "react-resizable";
import type { ResizeCallbackData } from "react-resizable";
export type AutosaveStatus = "idle" | "processing" | "error" | "stopped";
function StartLicense(stimulsoftInstance: any) {
    const key = process.env.REACT_APP_STIMULSOFT_LICENSE_KEY;
    if (key && key.trim() !== "") {
        try {
            stimulsoftInstance.Base.StiLicense.key = key.trim();
        } catch (error: any) { }
    } else {
        const hardcodedKey = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmKmIYtQbGVffUafn4grxXukjNz+mLI/d2lO8A9DuHxAxu4MmrN4lqhtklB0Pcnfq+AIk+1s6kU0D6JIIxpfQs1FV6pzwrzAWDLexRPvVgpswR/C5n69gFjFmWmtV0bGCTAj6H/MHgwElWYT9nYccmuFH0sfAj7VELa2HehqREJ7di+05AWeWIScfcWsf0XZ3JK+2X3reYvhUEAxrCwX3FDw2p1hPQIfiUVkUd4NRvfwWBLOjP2ZTfp9dzNe1D6T7miK1VBd731o/ex6q1bkdNH+G1KV6OLxdQwb9zWr4AR0QtMKwrphskgAYb5PMCectoVCeRFKtWSm8qnMP+GN8v0GHbJGQ/ZYWMAsE94nCEhnJz9T/xfy1b6WEWqpUUjVsfPzm/naRz0bxVN+AtFW7thTBMwGXoKTJXnKhfrI5u/fRffUu78ejnazBjWCHANN/xF7XOLhnFWw5JZHPXkaoCbiG8kBL3bgL4DtSyZ7jecAPmJUtainwLNMdo75J6hvu/pS+jDUs2tqRjEv6PTehXg";
        try {
            stimulsoftInstance.Base.StiLicense.key = hardcodedKey;
        } catch (fallbackError: any) { }
    }
}

export const STATUS_MAPPING: Record<string, string> = {
    "1": "Draft",
    "2": "New",
    "3": "Waiting for Approved",
    "4": "Complete",
    "5": "Canceled",
    "6": "QC Pass",
    "7": "On Going",
    "9": "Billing Preparation",
    "10": "Waiting for Approved",
    "33": "Wating for Approved QC Pass",
};

export const getStatusLabel = (status: string): string => {
    return STATUS_MAPPING[status] || status;
};

const formatDateStringToDMY = (dateVal: any): string | null => {
    if (!dateVal) return null;
    if (dayjs.isDayjs(dateVal)) return dateVal.format("DD/MM/YYYY");
    const dateStr = String(dateVal).trim();
    if (dateStr === "Invalid Date" || dateStr === "") return null;
    if (/^\d{2}\/\d{2}\/\d{4}/.test(dateStr)) {
        return dateStr.substring(0, 10);
    }
    if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
        const parts = dateStr.substring(0, 10).split("-");
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    const parsed = dayjs(dateVal);
    return parsed.isValid() ? parsed.format("DD/MM/YYYY") : null;
};

const CloseOrderModalContent: React.FC<{ onChange: (val: string) => void }> = ({ onChange }) => {
    const [value, setValue] = useState("Close Order");
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        let val = e.target.value;
        if (!val.startsWith("Close Order")) {
            val = "Close Order";
        }
        setValue(val);
        onChange(val);
    };
    return (
        <div>
            <p>Apakah Anda yakin ingin melakukan Close Order?:</p>
            <Input.TextArea rows={3} value={value} onChange={handleChange} />
        </div>
    );
};

const ReviseOrderModalContent: React.FC<{ onChange: (val: string) => void }> = ({ onChange }) => {
    const [value, setValue] = useState("Revise");
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        let val = e.target.value;
        if (!val.startsWith("Revise")) {
            val = "Revise";
        }
        setValue(val);
        onChange(val);
    };
    return (
        <div>
            <p>Apakah Anda yakin ingin melakukan Revise? :</p>
            <Input.TextArea rows={3} value={value} onChange={handleChange} />
        </div>
    );
};

export interface DataType {
    key: React.Key;
    no: number;
    description: string;
}

export interface RemarkDataType {
    key: React.Key;
    no: number;
    remarkDate: string;
    remark: string;
}

export interface BillingDataType {
    key: string;
    customerCode: string;
    customerName: string;
    customerType: string;
    address1: string;
    address2: string;
    phoneNumber: string;
    provinsi: string;
    provinsiCode: string;
    kabupaten: string;
    kabupatenCode: string;
    kecamatan: string;
    kecamatanCode: string;
    kelurahan: string;
    kelurahanCode: string;
    kodePos: string;
}

export interface CalculationDataType {
    key: React.Key;
    no: number;
    status?: string;
    type: string;
    trxType: string;
    jobType: string;
    number: string;
    description: string;
    uom: string;
    frtQty: number;
    supplyQty: string | number
    price: number;
    originalDisc: number;
    originalDiscAmount: number;
    proposalDisc: number;
    proposalDiscAmount: number;
    total: number;
    warehouse: string;
    hpp?: number;
    stockQty?: string | number;
}

export type ColumnTypes = Exclude<TableProps<DataType>["columns"], undefined>;
export type RemarkColumnTypes = Exclude<TableProps<RemarkDataType>["columns"], undefined>;

const EditableContext = React.createContext<FormInstance<any> | null>(null);

interface EditableRowProps {
    index: number;
}

const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

interface EditableCellProps {
    title: React.ReactNode;
    editable: boolean;
    dataIndex: keyof DataType;
    record: DataType;
    handleSave: (record: DataType) => void;
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = React.useState(false);
    const inputRef = useRef<InputRef>(null);
    const form = useContext(EditableContext)!;

    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({ [dataIndex]: record[dataIndex] });
    };

    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log("Save failed:", errInfo);
        }
    };

    let childNode = children;

    if (editable) {
        childNode = editing ? (
            <Form.Item style={{ margin: 0 }} name={dataIndex} rules={[{ required: true, message: `${title} is required.` }]}>
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div className="editable-cell-value-wrap" style={{ paddingRight: 24, cursor: "pointer" }} onClick={toggleEdit}>
                {children}
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

interface TableDescriptionProps {
    dataSource: DataType[];
    rowSelection: { selectedRowKeys: React.Key[]; onChange: (newSelectedRowKeys: React.Key[]) => void };
    handleDelete: (key: React.Key) => void;
    handleAdd: () => void;
    handleSave: (row: DataType) => void;
}

export const TableDescription: React.FC<TableDescriptionProps> = ({
    dataSource,
    rowSelection,
    handleDelete,
    handleAdd,
    handleSave,
}) => {
    const defaultColumns: (ColumnTypes[number] & { editable?: boolean; dataIndex: string })[] = [
        { title: "No", dataIndex: "no", width: "10%" },
        {
            title: (
                <>
                    Request Description <span style={{ color: "red" }}>*</span>
                </>
            ),
            dataIndex: "description",
            editable: true,
        },
        {
            title: "Action",
            dataIndex: "action",
            width: "15%",
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                        <a>Delete</a>
                    </Popconfirm>
                ) : null,
        },
    ];

    const components = { body: { row: EditableRow, cell: EditableCell } };

    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: DataType) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    return (
        <div>
            <Button onClick={handleAdd} type="primary" style={{ marginBottom: 16 }}>
                Add a row
            </Button>
            <Table
                className="table-description"
                components={components}
                rowClassName={() => "editable-row"}
                rowSelection={rowSelection}
                columns={columns as ColumnTypes}
                dataSource={dataSource}
                pagination={false}
                bordered
            />
        </div>
    );
};

const RemarkEditableContext = React.createContext<FormInstance<any> | null>(null);

interface RemarkEditableRowProps {
    index: number;
}

const RemarkEditableRow: React.FC<RemarkEditableRowProps> = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <RemarkEditableContext.Provider value={form}>
                <tr {...props} />
            </RemarkEditableContext.Provider>
        </Form>
    );
};

interface RemarkEditableCellProps {
    title: React.ReactNode;
    editable: boolean;
    dataIndex: keyof RemarkDataType;
    record: RemarkDataType;
    handleSave: (record: RemarkDataType) => void;
}

const RemarkEditableCell: React.FC<React.PropsWithChildren<RemarkEditableCellProps>> = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = React.useState(false);
    const inputRef = useRef<InputRef>(null);
    const form = useContext(RemarkEditableContext)!;

    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        const initialFormValues: any = { ...record };
        if (initialFormValues.remarkDate && typeof initialFormValues.remarkDate === "string") {
            initialFormValues.remarkDate = dayjs(initialFormValues.remarkDate, "DD/MM/YYYY");
        }
        form.setFieldsValue(initialFormValues);
    };

    const save = async () => {
        try {
            const values = await form.validateFields();
            let finalRemarkDate: string | null = record.remarkDate;

            if (dataIndex === "remarkDate" && values.remarkDate) {
                finalRemarkDate = dayjs.isDayjs(values.remarkDate)
                    ? values.remarkDate.format("DD/MM/YYYY")
                    : values.remarkDate;
            }
            handleSave({ ...record, ...values, remarkDate: finalRemarkDate });
            setEditing(false);
        } catch (errInfo) {
            console.log("Save failed:", errInfo);
        }
    };

    let childNode = children;

    if (editable) {
        childNode = editing ? (
            <Form.Item style={{ margin: 0 }} name={dataIndex} rules={[{ required: true, message: `${title} is required.` }]}>
                {dataIndex === "remarkDate" ? (
                    <DatePicker
                        ref={inputRef as any}
                        format="DD/MM/YYYY"
                        value={
                            form.getFieldValue(dataIndex)
                                ? dayjs.isDayjs(form.getFieldValue(dataIndex))
                                    ? form.getFieldValue(dataIndex)
                                    : dayjs(form.getFieldValue(dataIndex), "DD/MM/YYYY")
                                : null
                        }
                        onChange={(date, dateString) => {
                            form.setFieldsValue({ [dataIndex]: date });
                        }}
                        onBlur={save}
                        style={{ width: "100%" }}
                    />
                ) : (
                    <Input ref={inputRef} onPressEnter={save} onBlur={save} />
                )}
            </Form.Item>
        ) : (
            <div className="editable-cell-value-wrap" style={{ paddingRight: 24, cursor: "pointer" }} onClick={toggleEdit}>
                {children}
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

interface TableRemarkProps {
    dataSource: RemarkDataType[];
    rowSelection: { selectedRowKeys: React.Key[]; onChange: (newSelectedRowKeys: React.Key[]) => void };
    handleDelete: (key: React.Key) => void;
    handleAdd: () => void;
    handleSave: (row: RemarkDataType) => void;
}

export const TableRemark: React.FC<TableRemarkProps> = ({ dataSource, rowSelection, handleDelete, handleAdd, handleSave }) => {
    const defaultColumns: (RemarkColumnTypes[number] & { editable?: boolean; dataIndex: string })[] = [
        { title: "No", dataIndex: "no", width: "10%" },
        {
            title: (
                <>
                    Remark Date <span style={{ color: "red" }}>*</span>
                </>
            ),
            dataIndex: "remarkDate",
            editable: true,
        },
        {
            title: (
                <>
                    Remark <span style={{ color: "red" }}>*</span>
                </>
            ),
            dataIndex: "remark",
            editable: true,
        },
        {
            title: "Action",
            dataIndex: "action",
            width: "15%",
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                        <a>Delete</a>
                    </Popconfirm>
                ) : null,
        },
    ];

    const components = { body: { row: RemarkEditableRow, cell: RemarkEditableCell } };

    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: RemarkDataType) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    return (
        <div>
            <Button onClick={handleAdd} type="primary" style={{ marginBottom: 16 }}>
                Add a remark
            </Button>
            <Table
                className="table-remark"
                components={components}
                rowClassName={() => "editable-row"}
                rowSelection={rowSelection}
                columns={columns as RemarkColumnTypes}
                dataSource={dataSource}
                pagination={false}
                bordered
            />
        </div>
    );
};

type CalculationDataIndex = keyof CalculationDataType;
const ResizableTitle = (props: React.HTMLAttributes<any> & { onResize: (e: React.SyntheticEvent, data: ResizeCallbackData) => void; width: number; onDoubleClick: () => void; }) => {
    const { onResize, width, onDoubleClick, ...restProps } = props;
    if (!width) {
        return <th {...restProps} onDoubleClick={onDoubleClick} />;
    }
    return (
        <Resizable
            width={width}
            height={0}
            handle={
                <span
                    className="react-resizable-handle"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                />
            }
            onResize={onResize}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th {...restProps} onDoubleClick={onDoubleClick} />
        </Resizable>
    );
};

interface TableCalculationProps {
    dataSource: CalculationDataType[];
    columns: TableColumnsType<CalculationDataType>;
    onRow?: (record: CalculationDataType) => React.HTMLAttributes<HTMLElement>;
    rowSelection?: TableProps<CalculationDataType>["rowSelection"];
    lockedFields?: Record<string, { userName: string; socketId: string }>;
}


export const TableCalculation: React.FC<TableCalculationProps> = ({ dataSource, columns: propColumns, onRow, rowSelection, lockedFields }) => {
    const [widths, setWidths] = useState<Record<string, number>>({
        no: 60,
        status: 80,
        type: 120,
        trxType: 100,
        jobType: 130,
        number: 120,
        description: 200,
        uom: 80,
        frtQty: 100,
        supplyQty: 100,
        stockQty: 80,
        price: 120,
        proposalDisc: 120,
        proposalDiscAmount: 140,
        total: 120,
    });

    const [visibleKeys, setVisibleKeys] = useState<string[]>([
        "no", "status", "type", "trxType", "jobType", "number", "description", "uom", "frtQty", "supplyQty", "stockQty", "price", "proposalDisc", "proposalDiscAmount", "total"
    ]);

    const handleResize = (key: string) => (
        e: React.SyntheticEvent,
        { size }: ResizeCallbackData
    ) => {
        setWidths((prev) => ({
            ...prev,
            [key]: size.width,
        }));
    };

    const autoSizeColumn = (colKey: string) => {
        if (!dataSource) return;
        const FONT_STYLE = "14px 'Poppins', sans-serif";
        const PADDING = 45;
        const getTextWidth = (text: string, font: string): number => {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            if (context) {
                context.font = font;
                return context.measureText(text).width;
            }
            return 0;
        };
        const getRenderedText = (record: CalculationDataType, key: string): string => {
            const value = record[key as keyof CalculationDataType];
            if (value === undefined || value === null) return '';
            return String(value);
        };
        const headerColumn = propColumns.find(col => String(col.key || (col as any).dataIndex) === colKey);
        const headerText = headerColumn && headerColumn.title ? (typeof headerColumn.title === 'string' ? headerColumn.title : String(headerColumn.key || (headerColumn as any).dataIndex)) : '';
        const headerWidth = getTextWidth(headerText, `600 ${FONT_STYLE}`) + PADDING;
        const cellWidths = dataSource.map(item => {
            const cellText = getRenderedText(item, colKey);
            return getTextWidth(cellText, FONT_STYLE) + PADDING;
        });
        const maxContentWidth = Math.ceil(Math.max(headerWidth, ...cellWidths, 80));
        setWidths(prev => ({
            ...prev,
            [colKey]: maxContentWidth,
        }));
    };

    const resizableColumns = propColumns
        .filter(col => visibleKeys.includes(String(col.key || (col as any).dataIndex)))
        .map((col, index) => {
            const colKey = String(col.key || (col as any).dataIndex || index);
            const width = widths[colKey] || 120;
            return {
                ...col,
                width,
                ellipsis: true,
                title: (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <span style={{ whiteSpace: 'nowrap', marginRight: 4 }}>
                            {typeof col.title === 'function' ? col.title({}) : col.title}
                        </span>
                        <Button
                            type="text"
                            size="small"
                            style={{ padding: 0, height: 'auto', display: 'flex', alignItems: 'center' }}
                            icon={<EyeInvisibleOutlined style={{ fontSize: '12px', color: '#8c8c8c' }} />}
                            onClick={(e) => {
                                e.stopPropagation();
                                setVisibleKeys(prev => prev.filter(k => k !== colKey));
                            }}
                        /> { }
                    </div>
                ),
                onHeaderCell: (column: any) => ({
                    width,
                    onResize: handleResize(colKey),
                    onDoubleClick: () => { },
                }),
            };
        });

    const components = {
        header: {
            cell: ResizableTitle,
        },
    };

    const tableWidth = resizableColumns.reduce((sum, col) => sum + (col.width as number || 120), 0);

    return (
        <div> { }
            <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
                <Popover
                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                    title="Columns Visibility Setting"
                    trigger="click"
                    placement="bottomRight"
                    content={
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 300, overflowY: 'auto' }}>
                            {propColumns.map((col, index) => {
                                const colKey = String(col.key || (col as any).dataIndex || index);
                                const titleText = typeof col.title === 'string' ? col.title : String(col.key || (col as any).dataIndex || colKey);
                                return (
                                    <Checkbox
                                        key={colKey}
                                        checked={visibleKeys.includes(colKey)}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setVisibleKeys(prev =>
                                                checked ? [...prev, colKey] : prev.filter(k => k !== colKey)
                                            );
                                        }}
                                    >
                                        {titleText}
                                    </Checkbox>
                                );
                            })}
                        </div>
                    }
                >
                    <Button icon={<SettingOutlined />}>Columns Visibility</Button>
                </Popover>
            </div>
            <Table
                rowSelection={rowSelection}
                components={components}
                columns={resizableColumns as any}
                dataSource={dataSource}
                pagination={{ defaultPageSize: 8, showSizeChanger: true, pageSizeOptions: ["5", "10", "50", "100",] }}
                bordered
                scroll={{ x: tableWidth }}
                onRow={onRow}
                rowClassName={(record) => (record.status === "R" ? "row-red-status" : lockedFields?.[`row_${record.key}`] ? "table-row-locked" : "")}
            />
        </div>
    );
};

export interface WithWorkOrderLogicProps {
    descriptionDataSource: DataType[];
    descriptionRowSelection: { selectedRowKeys: React.Key[]; onChange: (newSelectedRowKeys: React.Key[]) => void };
    handleDescriptionDelete: (key: React.Key) => void;
    handleDescriptionAdd: () => void;
    handleDescriptionSave: (row: DataType) => void;
    remarkDataSource: RemarkDataType[];
    remarkRowSelection: { selectedRowKeys: React.Key[]; onChange: (newSelectedRowKeys: React.Key[]) => void };
    handleRemarkDelete: (key: React.Key) => void;
    handleRemarkAdd: () => void;
    handleRemarkSave: (row: RemarkDataType) => void;
    isModalOpen: boolean;
    showModal: () => void;
    handleOk: () => void;
    handleCancel: () => void;
    isChassisModalOpen: boolean;
    showChassisModal: () => void;
    handleChassisOk: () => void;
    handleChassisCancel: () => void;
    form: FormInstance<any>;
    handleChassisSelect: (record: Partial<ChassisDataType>) => void;
    handleBillingSelect: (record: Partial<BillingDataType>) => void;
    calculationDataSource: CalculationDataType[];
    calculationColumns: TableColumnsType<CalculationDataType>;
    calculationRowSelection: { selectedRowKeys: React.Key[]; onChange: (newSelectedRowKeys: React.Key[]) => void };
    handleCalculationDelete: () => void;
    handleCalculationAddRow: () => void;
    isAddEditModalOpen: boolean;
    showAddEditModal: () => void;
    handleAddEditOk: () => void;
    handleAddEditCancel: () => void;
    isCurrentUserDetailsVisible: boolean;
    toggleCurrentUserDetails: () => void;
    isVehicleDetailsVisible: boolean;
    toggleVehicleDetails: () => void;
    isStnkDetailsVisible: boolean;
    toggleStnkDetails: () => void;
    isBillingDetailsVisible: boolean;
    toggleBillingDetails: () => void;
    isCalculationVisible: boolean;
    toggleCalculation: () => void;
    addEditForm: FormInstance<any>;
    handleCalculationSubmit: (values: any) => void;
    handleCalculationEdit: (record: CalculationDataType) => Promise<void>;
    editingRecord: CalculationDataType | null;
    brands: { label: string; value: string }[];
    models: { label: string; value: string }[];
    warehouses: { label: string; value: string }[];
    autosaveStatus: AutosaveStatus;
    handleFormChange: (changedValues: any, allValues: any) => void;
    ppnValue: number;
    handleSubmitWorkOrder: () => Promise<void>;
    handleVoidWorkOrder: () => Promise<void>;
    handleCloseOrder: () => Promise<void>;
    serviceAdvisorName: string;
    handlePrintWorkOrder: () => Promise<void>;
    isPrinting: boolean;
    handleNew: () => Promise<void>;
    handleReviseWorkOrder: () => Promise<void>;
    isReportModalOpen: boolean;
    handleReportModalCancel: () => void;
    handleRefreshCalculations: () => Promise<void>;
    lockedFields: Record<string, { userName: string; socketId: string }>;
    onFieldFocus: (fieldName: string) => void;
    onFieldBlur: (fieldName: string) => void;
    onFormValuesChange: (changedValues: any, allValues: any) => void;
}

const sortAndRecalculateNo = (data: CalculationDataType[]): CalculationDataType[] => {
    return [...data]
        .sort((a, b) => {
            const aType = String(a.type);
            const bType = String(b.type);
            if (aType === "4" && bType !== "4") return -1;
            if (aType !== "4" && bType === "4") return 1;
            return Number(a.no) - Number(b.no);
        })
        .map((item, index) => ({ ...item, no: index + 1 }));
};

export const withWorkOrderLogic = <P extends object>(WrappedComponent: React.ComponentType<P & WithWorkOrderLogicProps>) => {
    const WorkOrderWithLogic: React.FC<P & { weNo?: string }> = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const { weNo: propWeNo } = props;
        const weNoFromState = propWeNo || (location.state as { weNo?: string })?.weNo || sessionStorage.getItem("active_weNo") || "";
        const { userData, socket } = useAuth();
        const fetcher = (url: string) => axios.get(url).then((res) => res.data);
        const { data: brandsData } = useSWR(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/brands`, fetcher);
        const { data: modelsData } = useSWR(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/models`, fetcher);
        const { data: warehousesData } = useSWR(
            userData?.kode_grup1
                ? `${process.env.REACT_APP_BACKEND_URL}/api/work-order/warehouses?kode_grup1=${userData.kode_grup1}`
                : null,
            fetcher,
        );

        const { data: ppnData } = useSWR(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/ppn-value`, fetcher);
        const ppnValue = ppnData?.value_ppn || 0;

        const { data: existingWorkOrderData } = useSWR(
            weNoFromState ? `${process.env.REACT_APP_BACKEND_URL}/api/work-order/${weNoFromState}` : null,
            fetcher,
        );

        const [form] = Form.useForm();
        const [autosaveStatus, setAutosaveStatus] = useState<AutosaveStatus>("stopped");
        const [lockedFields, setLockedFields] = useState<Record<string, { userName: string; socketId: string }>>({});
        const currentWeNo = Form.useWatch("work_estimation_no", form) || weNoFromState || sessionStorage.getItem("active_weNo");

        useEffect(() => {
            if (!socket || !currentWeNo) return;
            socket.emit("join_wo_room", { weNo: currentWeNo });

            const handleCurrentLocks = (locks: Record<string, { userName: string; socketId: string }>) => {
                setLockedFields(locks);
            };
            const handleFieldLocked = (data: { fieldName: string; userName: string; socketId: string }) => {
                setLockedFields((prev) => ({ ...prev, [data.fieldName]: { userName: data.userName, socketId: data.socketId } }));
            };
            const handleFieldUnlocked = (data: { fieldName: string }) => {
                setLockedFields((prev) => {
                    const updated = { ...prev };
                    delete updated[data.fieldName];
                    return updated;
                });
            };
            const handleReceiveSyncData = (data: { changedValues?: any; allValues?: any; descriptions?: DataType[]; remarks?: RemarkDataType[]; calculations?: CalculationDataType[] }) => {
                const parseSyncDate = (values: any) => {
                    if (!values) return values;
                    const formatted = { ...values };
                    if (formatted.arrival_time && dayjs(formatted.arrival_time).isValid()) {
                        formatted.arrival_time = dayjs(formatted.arrival_time);
                    }
                    if (formatted.estimated_duration && dayjs(formatted.estimated_duration, "HH:mm").isValid()) {
                        formatted.estimated_duration = dayjs(formatted.estimated_duration, "HH:mm");
                    }
                    return formatted;
                };
                if (data.changedValues) form.setFieldsValue(parseSyncDate(data.changedValues));
                if (data.allValues) form.setFieldsValue(parseSyncDate(data.allValues));
                if (data.descriptions) setDescriptionDataSource(data.descriptions);
                if (data.remarks) setRemarkDataSource(data.remarks);
                if (data.calculations) setCalculationDataSource(data.calculations);
            };

            socket.on("wo_current_locks", handleCurrentLocks);
            socket.on("wo_field_locked", handleFieldLocked);
            socket.on("wo_field_unlocked", handleFieldUnlocked);
            socket.on("wo_receive_sync_data", handleReceiveSyncData);

            return () => {
                socket.emit("leave_wo_room", { weNo: currentWeNo });
                socket.off("wo_current_locks", handleCurrentLocks);
                socket.off("wo_field_locked", handleFieldLocked);
                socket.off("wo_field_unlocked", handleFieldUnlocked);
                socket.off("wo_receive_sync_data", handleReceiveSyncData);
            };
        }, [socket, currentWeNo, form]);

        const onFieldFocus = useCallback((fieldName: string) => {
            if (socket && currentWeNo) {
                socket.emit("wo_lock_field", {
                    weNo: currentWeNo,
                    fieldName,
                    userName: userData?.nama || "User Lain"
                });
            }
        }, [socket, currentWeNo, userData]);

        const onFieldBlur = useCallback((fieldName: string) => {
            if (socket && currentWeNo) {
                socket.emit("wo_unlock_field", {
                    weNo: currentWeNo,
                    fieldName
                });
            }
        }, [socket, currentWeNo]);
        useEffect(() => {
            if (autosaveStatus === "processing") {
                window.history.pushState(null, "", window.location.href);
                const handlePopState = () => {
                    window.history.pushState(null, "", window.location.href);
                    notification.warning({
                        message: "Penyimpanan Berjalan",
                        description: "Mohon tunggu hingga proses autosave selesai sebelum berpindah halaman.",
                        placement: "topRight",
                    });
                };
                window.addEventListener("popstate", handlePopState);
                return () => {
                    window.removeEventListener("popstate", handlePopState);
                    window.history.back();
                };
            }
        }, [autosaveStatus]);
        const [serviceAdvisorName, setServiceAdvisorName] = useState<string>("");
        const [isPrinting, setIsPrinting] = useState<boolean>(false);
        const [isReportModalOpen, setIsReportModalOpen] = useState(false)
        const previousDataRef = useRef<any>(null);
        const [descriptionDataSource, setDescriptionDataSource] = useState<DataType[]>([]);
        const [descriptionCount, setDescriptionCount] = useState(0);
        const [descriptionSelectedRowKeys, setDescriptionSelectedRowKeys] = useState<React.Key[]>([]);
        const [codes, setCodes] = useState<{ [key: string]: string | number | undefined }>({});

        const onDescriptionSelectChange = (newSelectedRowKeys: React.Key[]) => {
            console.log("selectedRowKeys changed: ", newSelectedRowKeys);
            setDescriptionSelectedRowKeys(newSelectedRowKeys);
        };

        const descriptionRowSelection = { selectedRowKeys: descriptionSelectedRowKeys, onChange: onDescriptionSelectChange };

        const handleDescriptionDelete = (key: React.Key) => {
            const updatedData = descriptionDataSource
                .filter((item) => item.key !== key)
                .map((item, index) => ({ ...item, no: index + 1 }));
            setDescriptionDataSource(updatedData);
        };

        const handleDescriptionAdd = () => {
            const newKey = descriptionCount;
            const newData: DataType = {
                key: newKey,
                no: descriptionDataSource.length + 1,
                description: `Please add a description`,
            };
            setDescriptionDataSource([...descriptionDataSource, newData]);
            setDescriptionCount(descriptionCount + 1);
        };

        const handleDescriptionSave = (row: DataType) => {
            const newData = [...descriptionDataSource];
            const index = newData.findIndex((item) => row.key === item.key);
            const item = newData[index];
            newData.splice(index, 1, { ...item, ...row });
            setDescriptionDataSource(newData);
        };

        const [remarkDataSource, setRemarkDataSource] = useState<RemarkDataType[]>([]);
        const [remarkCount, setRemarkCount] = useState(0);
        const [remarkSelectedRowKeys, setRemarkSelectedRowKeys] = useState<React.Key[]>([]);

        const onRemarkSelectChange = (newSelectedRowKeys: React.Key[]) => {
            console.log("selectedRowKeys changed: ", newSelectedRowKeys);
            setRemarkSelectedRowKeys(newSelectedRowKeys);
        };

        const remarkRowSelection = { selectedRowKeys: remarkSelectedRowKeys, onChange: onRemarkSelectChange };

        const handleRemarkDelete = (key: React.Key) => {
            const updatedData = remarkDataSource
                .filter((item) => item.key !== key)
                .map((item, index) => ({ ...item, no: index + 1 }));
            setRemarkDataSource(updatedData);
        };

        const handleRemarkAdd = () => {
            const newKey = remarkCount;
            const newData: RemarkDataType = {
                key: newKey,
                no: remarkDataSource.length + 1,
                remarkDate: dayjs().format("DD/MM/YYYY"),
                remark: `Please add a remark`,
            };
            setRemarkDataSource([...remarkDataSource, newData]);
            setRemarkCount(remarkCount + 1);
        };

        const handleRemarkSave = (row: RemarkDataType) => {
            const newData = [...remarkDataSource];
            const index = newData.findIndex((item) => row.key === item.key);
            const item = newData[index];
            newData.splice(index, 1, { ...item, ...row });
            setRemarkDataSource(newData);
        };

        const [calculationDataSource, setCalculationDataSource] = useState<CalculationDataType[]>([]);
        const [calculationCount, setCalculationCount] = useState(0);
        const [calculationSelectedRowKeys, setCalculationSelectedRowKeys] = useState<React.Key[]>([]);
        const [searchText, setSearchText] = useState("");
        const latestCalculationsRef = useRef({ sub_total: 0, discount: 0, total: 0, vat: 0, grand_total: 0 });
        const [searchedColumn, setSearchedColumn] = useState("");
        const searchInput = useRef<InputRef>(null);

        const calculatedSubTotal = useMemo(() => {
            return calculationDataSource
                .filter((item) => item.status !== "R")
                .reduce((sum, item) => sum + Number(item.total || 0), 0);
        }, [calculationDataSource]);

        const calculatedDiscount = useMemo(() => {
            return calculationDataSource
                .filter((item) => item.status !== "R")
                .reduce((sum, item) => {
                    const discAmount = Number(item.proposalDiscAmount || 0);
                    const qty = Number(item.frtQty || 0);
                    if (item.type === "4") {
                        return sum + discAmount;
                    }
                    return sum + discAmount * qty;
                }, 0);
        }, [calculationDataSource]);

        const calculatedTotal = useMemo(() => {
            const total = Number(calculatedSubTotal);
            return Number(total.toFixed(2));
        }, [calculatedSubTotal]);

        const calculatedVat = useMemo(() => {
            const vatAmount = (calculatedTotal * ppnValue) / 100;
            return Number(vatAmount.toFixed(2));
        }, [calculatedTotal, ppnValue]);

        const calculatedGrandTotal = useMemo(() => {
            const grandTotalAmount = calculatedTotal + calculatedVat;
            return Number(grandTotalAmount.toFixed(2));
        }, [calculatedTotal, calculatedVat]);

        useEffect(() => {
            form.setFieldsValue({
                sub_total: calculatedSubTotal,
                discount: calculatedDiscount,
                total: calculatedTotal,
                vat: calculatedVat,
                grand_total: calculatedGrandTotal,
            });
            latestCalculationsRef.current = {
                sub_total: calculatedSubTotal,
                discount: calculatedDiscount,
                total: calculatedTotal,
                vat: calculatedVat,
                grand_total: calculatedGrandTotal,
            };
        }, [form, calculatedSubTotal, calculatedDiscount, calculatedTotal, calculatedVat, calculatedGrandTotal]);

        const onCalculationSelectChange = (newSelectedRowKeys: React.Key[]) => {
            console.log("selectedRowKeys changed: ", newSelectedRowKeys);
            setCalculationSelectedRowKeys(newSelectedRowKeys);
        };

        const calculationRowSelection = {
            selectedRowKeys: calculationSelectedRowKeys,
            onChange: onCalculationSelectChange,
            getCheckboxProps: (record: CalculationDataType) => ({
                disabled: !!lockedFields[`row_${record.key}`],
            }),
        };

        const handleCalculationDelete = () => {
            const selectedItems = calculationDataSource.filter((item) => calculationSelectedRowKeys.includes(item.key));
            const hasActiveSupply = selectedItems.some((item) => item.number !== "External Part" && Number(item.supplyQty || 0) > 0);

            if (hasActiveSupply) {
                Modal.warning({
                    title: "Peringatan",
                    content: "Tidak bisa di hapus ! Item belum di return, hubungi tim Inventory",
                });
                return;
            }
            const updatedData = calculationDataSource.filter((item) => !calculationSelectedRowKeys.includes(item.key));
            setCalculationDataSource(sortAndRecalculateNo(updatedData));
            setCalculationSelectedRowKeys([]);
        };

        const [inlineLoadingKeys, setInlineLoadingKeys] = useState<Record<string, boolean>>({});

        const updateInlineRow = (key: React.Key, updatedFields: Partial<CalculationDataType>) => {
            setCalculationDataSource((prev) =>
                prev.map((item) => {
                    if (item.key === key) {
                        const updated = { ...item, ...updatedFields };
                        return updated;
                    }
                    return item;
                })
            );
        };

        const performInlineSearch = async (rowKey: React.Key, numberVal: string, type: string, trxType: string) => {
            const warehouse = form.getFieldValue("warehouse") || userData?.warehouse_code;
            if (!warehouse || !numberVal) return;
            setInlineLoadingKeys(prev => ({ ...prev, [String(rowKey)]: true }))
            await new Promise(resolve => setTimeout(resolve, 2000));

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/work-order/modal-items?warehouse_group=${warehouse}&type=${type}&search=${numberVal}&limit=1`
                );
                const foundItem = response.data?.data?.[0];
                if (foundItem && foundItem.code.toLowerCase() === numberVal.toLowerCase()) {
                    const flatPrice = parseFloat(foundItem.price_flate_rate || "0");
                    const resolvedPrice = (type === '4' && foundItem.source_type === 'service') ? flatPrice : foundItem.price;
                    const qty = type === '4' && foundItem.source_type === 'service' ? Number(foundItem.available_qty || 0) : 0;
                    const subTotal = resolvedPrice * qty;

                    updateInlineRow(rowKey, {
                        description: foundItem.description,
                        uom: foundItem.source_type === 'service' ? '' : foundItem.uom,
                        stockQty: foundItem.source_type === 'service' ? '-' : foundItem.available_qty,
                        price: resolvedPrice,
                        frtQty: qty,
                        total: subTotal,
                    });
                } else {
                    updateInlineRow(rowKey, {
                        description: "Item Not Found",
                        uom: "",
                        stockQty: "-",
                        price: 0,
                        total: 0,
                    });
                }
            } catch (error) {
                console.error("Inline search failed", error);
            } finally {
                setInlineLoadingKeys(prev => ({ ...prev, [String(rowKey)]: false }));
            }
        };

        const debouncedSearch = useMemo(
            () =>
                debounce((key: React.Key, val: string, type: string, trxType: string) => {
                    performInlineSearch(key, val, type, trxType);
                }, 1500),
            [form, userData]
        );

        useEffect(() => {
            return () => {
                debouncedSearch.cancel();
            };
        }, [debouncedSearch]);

        const handleCalculationAddRow = () => {
            const newKey = `inline_${Date.now()}`;
            const warehouse = form.getFieldValue("warehouse") || userData?.warehouse_code || "";
            const newData: CalculationDataType & { isInlineEditing?: boolean } = {
                key: newKey,
                no: calculationDataSource.length + 1,
                type: "",
                trxType: "",
                jobType: "",
                number: "",
                description: "",
                uom: "",
                frtQty: 0,
                supplyQty: 0,
                price: 0,
                originalDisc: 0,
                originalDiscAmount: 0,
                proposalDisc: 0,
                proposalDiscAmount: 0,
                total: 0,
                warehouse: warehouse,
                hpp: 0,
                stockQty: "-",
                isInlineEditing: true,
            };
            setCalculationDataSource((prev) => [...prev, newData]);
        };

        const handleSearch = (
            selectedKeys: string[],
            confirm: FilterDropdownProps["confirm"],
            dataIndex: CalculationDataIndex,
        ) => {
            confirm();
            setSearchText(selectedKeys[0]);
            setSearchedColumn(dataIndex);
        };

        const handleReset = (clearFilters: () => void) => {
            clearFilters();
            setSearchText("");
        };

        const getColumnSearchProps = (dataIndex: CalculationDataIndex): TableColumnType<CalculationDataType> => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
                <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                    <Input
                        ref={searchInput}
                        placeholder={`Search ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        style={{ marginBottom: 8, display: "block" }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}>
                            Search
                        </Button>
                        <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Reset
                        </Button>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                confirm({ closeDropdown: false });
                                setSearchText((selectedKeys as string[])[0]);
                                setSearchedColumn(dataIndex);
                            }}>
                            Filter
                        </Button>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                close();
                            }}>
                            close
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: boolean) => <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />,
            onFilter: (value, record) =>
                String(record[dataIndex] ?? "")
                    .toLowerCase()
                    .includes((value as string).toLowerCase()),
            filterDropdownProps: {
                onOpenChange(open) {
                    if (open) {
                        setTimeout(() => searchInput.current?.select(), 100);
                    }
                },
            },
            render: (text) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ""}
                    />
                ) : (
                    text
                ),
        });

        const calculationColumns: TableColumnsType<CalculationDataType> = [
            {
                title: "No",
                dataIndex: "no",
                key: "no",
                sorter: (a, b) => a.no - b.no,
                defaultSortOrder: "ascend",
                ...getColumnSearchProps("no"),
            },
            { title: "Status", dataIndex: "status", key: "status", ...getColumnSearchProps("status") },
            {
                title: "Type",
                dataIndex: "type",
                key: "type",
                sorter: (a, b) => (a.type || "").toString().localeCompare((b.type || "").toString()),
                ...getColumnSearchProps("type"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <Select
                                optionLabelProp="value"
                                value={record.type}
                                style={{ width: 120 }}
                                onChange={(val) => {
                                    updateInlineRow(record.key, { type: val });
                                }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                popupMatchSelectWidth={false}
                                options={[
                                    { label: "Sparepart", value: "1" },
                                    { label: "Operation", value: "4" },
                                ]}
                            />
                        );
                    }
                    return text;
                },
            },
            {
                title: "Trx Type",
                dataIndex: "trxType",
                key: "trxType",
                sorter: (a, b) => (a.trxType || "").toString().localeCompare((b.trxType || "").toString()),
                ...getColumnSearchProps("trxType"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <Select
                                optionLabelProp="value"
                                value={record.trxType}
                                style={{ width: 100 }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                popupMatchSelectWidth={false}
                                onChange={(val) => {
                                    updateInlineRow(record.key, { trxType: val });
                                }}
                                options={[
                                    { label: "Internal", value: "1" },
                                ]}
                            />
                        );
                    }
                    return text;
                },
            },
            {
                title: "Job Type",
                dataIndex: "jobType",
                key: "jobType",
                sorter: (a, b) => (a.jobType || "").toString().localeCompare((b.jobType || "").toString()),
                ...getColumnSearchProps("jobType"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <Select
                                optionLabelProp="value"
                                value={record.jobType}
                                style={{ width: 130 }}
                                onChange={(val) => {
                                    updateInlineRow(record.key, { jobType: val });
                                }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                popupMatchSelectWidth={false}
                                options={[
                                    { label: "General Repair", value: "GR" },
                                    { label: "Periodical Maintenance", value: "PM" },
                                ]}
                            />
                        );
                    }
                    return text;
                },
            },
            {
                title: "Number",
                dataIndex: "number",
                key: "number",
                sorter: (a, b) => (a.number || "").toString().localeCompare((b.number || "").toString()),
                ...getColumnSearchProps("number"),
                render: (text: any, record: any) => {
                    const lock = lockedFields[`row_${record.key}`];
                    if (record.isInlineEditing) {
                        const isLoading = inlineLoadingKeys[record.key];
                        return (
                            <Space>
                                <Input
                                    value={record.number}
                                    style={{ width: 120 }}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        const isDuplicate = calculationDataSource.some(
                                            (item) => item.key !== record.key && item.number && item.number.trim().toLowerCase() === val.trim().toLowerCase()
                                        );
                                        if (isDuplicate && val.trim() !== "") {
                                            Modal.warning({
                                                title: "Peringatan",
                                                content: "Item Part sudah ada !",
                                            });
                                            updateInlineRow(record.key, { number: "" });
                                            return;
                                        }
                                        updateInlineRow(record.key, { number: val });
                                        debouncedSearch(record.key, val, record.type, record.trxType);
                                    }}
                                />
                                {isLoading && <LoadingOutlined />}
                            </Space>
                        );
                    }
                    if (lock) {
                        return (
                            <Tooltip title={`Sedang diedit oleh ${lock.userName}`}>
                                <span style={{ color: "#faad14", fontWeight: "bold" }}>
                                    {text} (🔒 {lock.userName})
                                </span>
                            </Tooltip>
                        );
                    }
                    return text;
                },
            },
            {
                title: "Description",
                dataIndex: "description",
                key: "description",
                sorter: (a, b) => (a.description || "").toString().localeCompare((b.description || "").toString()),
                ...getColumnSearchProps("description"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <Input
                                value={record.description}
                                readOnly
                            />
                        );
                    }
                    return text;
                },
            },
            {
                title: "UoM",
                dataIndex: "uom",
                key: "uom",
                sorter: (a, b) => (a.uom || "").toString().localeCompare((b.uom || "").toString()),
                ...getColumnSearchProps("uom"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <Input
                                value={record.uom}
                                onChange={(e) => updateInlineRow(record.key, { uom: e.target.value })}
                            />
                        );
                    }
                    return text;
                },
            },
            {
                title: "FRT/Qty",
                dataIndex: "frtQty",
                key: "frtQty",
                sorter: (a, b) => a.frtQty - b.frtQty,
                ...getColumnSearchProps("frtQty"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <InputNumber
                                value={record.frtQty}
                                min={0}
                                onChange={(val) => {
                                    const qty = Number(val || 0);
                                    const price = record.price || 0;
                                    const discAmt = record.proposalDiscAmount || 0;
                                    const total = (price - discAmt) * qty;
                                    updateInlineRow(record.key, { frtQty: qty, total: total });
                                }}
                            />
                        );
                    }
                    return text;
                },
            },
            {
                title: "Supply Qty",
                dataIndex: "supplyQty",
                key: "supplyQty",
                sorter: (a, b) => String(a.supplyQty || "").localeCompare(String(b.supplyQty || "")),
                ...getColumnSearchProps("supplyQty"),
            },
            {
                title: "Stock",
                dataIndex: "stockQty",
                key: "stockQty",
                sorter: (a, b) => {
                    const aVal = typeof a.stockQty === "number" ? a.stockQty : parseFloat(String(a.stockQty || 0)) || 0;
                    const bVal = typeof b.stockQty === "number" ? b.stockQty : parseFloat(String(b.stockQty || 0)) || 0;
                    return aVal - bVal;
                },
                ...getColumnSearchProps("stockQty"),
            },
            {
                title: "Price",
                dataIndex: "price",
                key: "price",
                sorter: (a, b) => a.price - b.price,
                ...getColumnSearchProps("price"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <InputNumber
                                value={record.price}
                                min={0}
                                onChange={(val) => {
                                    const price = Number(val || 0);
                                    const qty = record.frtQty || 0;
                                    const discPercent = record.proposalDisc || 0;
                                    const calculatedDiscAmt = (price * discPercent) / 100;
                                    const total = (price - calculatedDiscAmt) * qty;
                                    updateInlineRow(record.key, {
                                        price: price,
                                        proposalDiscAmount: calculatedDiscAmt,
                                        total: total
                                    });
                                }}
                            />
                        );
                    }
                    const numericValue = Number(text);
                    return !isNaN(numericValue) ? numericValue.toLocaleString("id-ID") : text;
                },
            },
            {
                title: "Proposal Disc %",
                dataIndex: "proposalDisc",
                key: "proposalDisc",
                sorter: (a, b) => a.proposalDisc - b.proposalDisc,
                ...getColumnSearchProps("proposalDisc"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <InputNumber
                                value={record.proposalDisc}
                                min={0}
                                max={100}
                                onChange={(val) => {
                                    const discPercent = Number(val || 0);
                                    const price = record.price || 0;
                                    const qty = record.frtQty || 0;
                                    const calculatedDiscAmt = (price * discPercent) / 100;
                                    const total = (price - calculatedDiscAmt) * qty;
                                    updateInlineRow(record.key, {
                                        proposalDisc: discPercent,
                                        proposalDiscAmount: calculatedDiscAmt,
                                        total: total
                                    });
                                }}
                            />
                        );
                    }
                    return text;
                },
            },
            {
                title: "Proposal Disc. Amount",
                dataIndex: "proposalDiscAmount",
                key: "proposalDiscAmount",
                sorter: (a, b) => a.proposalDiscAmount - b.proposalDiscAmount,
                ...getColumnSearchProps("proposalDiscAmount"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <InputNumber
                                value={record.proposalDiscAmount}
                                min={0}
                                onChange={(val) => {
                                    const discAmt = Number(val || 0);
                                    const price = record.price || 0;
                                    const qty = record.frtQty || 0;
                                    const calculatedDiscPercent = price > 0 ? (discAmt / price) * 100 : 0;
                                    const total = (price - discAmt) * qty;
                                    updateInlineRow(record.key, {
                                        proposalDiscAmount: discAmt,
                                        proposalDisc: Number(calculatedDiscPercent.toFixed(2)),
                                        total: total
                                    });
                                }}
                            />
                        );
                    }
                    const numericValue = Number(text);
                    return !isNaN(numericValue) ? numericValue.toLocaleString("id-ID") : text;
                },
            },
            {
                title: "Total",
                dataIndex: "total",
                key: "total",
                sorter: (a, b) => a.total - b.total,
                ...getColumnSearchProps("total"),
                render: (text: any, record: any) => {
                    if (record.isInlineEditing) {
                        return (
                            <span>{Number(record.total || 0).toLocaleString("id-ID")}</span>
                        );
                    }
                    const numericValue = Number(text);
                    return !isNaN(numericValue) ? numericValue.toLocaleString("id-ID") : text;
                },
            },
        ];

        const [isModalOpen, setIsModalOpen] = useState(false);

        const showModal = () => {
            setIsModalOpen(true);
        };

        const handleOk = () => {
            setIsModalOpen(false);
        };

        const handleCancel = () => {
            setIsModalOpen(false);
        };

        const [isChassisModalOpen, setIsChassisModalOpen] = useState(false);

        const showChassisModal = () => {
            setIsChassisModalOpen(true);
        };

        const handleChassisOk = () => {
            setIsChassisModalOpen(false);
        };

        const handleChassisCancel = () => {
            setIsChassisModalOpen(false);
        };

        const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
        const [addEditForm] = Form.useForm();
        const [editingRecord, setEditingRecord] = useState<CalculationDataType | null>(null);

        const showAddEditModal = () => {
            setEditingRecord(null);
            addEditForm.resetFields();
            setIsAddEditModalOpen(true);
        };

        const handleAddEditOk = () => {
            if (editingRecord) {
                onFieldBlur(`row_${editingRecord.key}`);
            }
            addEditForm.resetFields();
            setEditingRecord(null);
            setIsAddEditModalOpen(false);
        };

        const handleAddEditCancel = () => {
            if (editingRecord) {
                onFieldBlur(`row_${editingRecord.key}`);
            }
            addEditForm.resetFields();
            setEditingRecord(null);
            setIsAddEditModalOpen(false);
        };

        const handleCalculationSubmit = (values: any) => {
            const safeStockQty = isNaN(parseFloat(values.supply_qty)) ? 0 : parseFloat(values.supply_qty);
            if (editingRecord) {
                const updatedData = calculationDataSource.map((item) =>
                    item.key === editingRecord.key
                        ? {
                            ...item,
                            type: values.type,
                            trxType: values.trx_type,
                            jobType: values.job_type,
                            number: values.item_code,
                            description: values.item_name,
                            uom: values.type === "4" && values.uom === "Minutes" ? "" : values.uom,
                            frtQty: Number(values.qty),
                            supplyQty: item.supplyQty,
                            price: Number(values.price),
                            proposalDisc: parseFloat(values.disc_percent) || 0,
                            proposalDiscAmount: Number(values.disc_amount),
                            total: Number(values.total),
                            warehouse: values.warehouse,
                            hpp: Number(values.hpp) || 0,
                            tockQty: item.stockQty
                        }
                        : item,
                );
                setCalculationDataSource(sortAndRecalculateNo(updatedData));
            } else {
                const newKey = calculationCount;
                const newData: CalculationDataType = {
                    key: newKey,
                    no: calculationDataSource.length + 1,
                    type: values.type,
                    trxType: values.trx_type,
                    jobType: values.job_type,
                    number: values.item_code,
                    description: values.item_name,
                    uom: values.type === "4" && values.uom === "Minutes" ? "" : values.uom,
                    frtQty: Number(values.qty),
                    supplyQty: 0,
                    price: Number(values.price),
                    originalDisc: 0,
                    originalDiscAmount: 0,
                    proposalDisc: parseFloat(values.disc_percent) || 0,
                    proposalDiscAmount: Number(values.disc_amount),
                    total: Number(values.total),
                    warehouse: values.warehouse,
                    hpp: Number(values.hpp) || 0,
                    stockQty: values.type === "1" ? safeStockQty : "-",
                };
                setCalculationDataSource((prevData) => sortAndRecalculateNo([...prevData, newData]));
                setCalculationCount((prevCount) => prevCount + 1);
            }
            if (editingRecord) {
                onFieldBlur(`row_${editingRecord.key}`);
            }
            setEditingRecord(null);
        };

        const handleCalculationEdit = async (record: CalculationDataType) => {
            const lockKey = `row_${record.key}`;
            if (lockedFields[lockKey]) {
                notification.warning({
                    message: "Baris Sedang Terkunci",
                    description: `Item ini sedang diedit oleh ${lockedFields[lockKey].userName}`,
                });
                return;
            }
            onFieldFocus(lockKey);
            setEditingRecord(record);
            setIsAddEditModalOpen(true);
            const rawStock = String(record.stockQty || "0");
            const parsedStock = isNaN(parseFloat(rawStock)) ? 0 : parseFloat(rawStock);
            let latestSupplyQty = record.type === "1" ? parsedStock : record.supplyQty;
            if (record.type === "1") {
                axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/work-order/spareparts-items?warehouse_group=${record.warehouse}`,
                )
                    .then((response) => {
                        const masterItem = response.data.find((item: any) => item.code === record.number);
                        if (masterItem) {
                            addEditForm.setFieldsValue({ supply_qty: masterItem.available_qty });
                        }
                    })
                    .catch((err) => console.error("Gagal fetch stok:", err));
            }
            addEditForm.setFieldsValue({
                type: record.type,
                trx_type: record.trxType,
                job_type: record.jobType,
                item_code: record.number,
                item_name: record.description,
                uom: record.uom,
                qty: record.frtQty,
                supply_qty: latestSupplyQty,
                hpp: record.hpp,
                price: record.price,
                sub_total: record.price * record.frtQty,
                disc_percent: record.proposalDisc,
                disc_amount: record.proposalDiscAmount,
                total: record.total,
                warehouse: record.warehouse,
            });
            setIsAddEditModalOpen(true);
        };

        const [isCurrentUserDetailsVisible, setIsCurrentUserDetailsVisible] = useState(true);
        const [isVehicleDetailsVisible, setIsVehicleDetailsVisible] = useState(true);
        const [isStnkDetailsVisible, setIsStnkDetailsVisible] = useState(true);
        const [isBillingDetailsVisible, setIsBillingDetailsVisible] = useState(true);
        const [isCalculationVisible, setIsCalculationVisible] = useState(true);
        const toggleCurrentUserDetails = () => setIsCurrentUserDetailsVisible(!isCurrentUserDetailsVisible);
        const toggleVehicleDetails = () => setIsVehicleDetailsVisible(!isVehicleDetailsVisible);
        const toggleStnkDetails = () => setIsStnkDetailsVisible(!isStnkDetailsVisible);
        const toggleBillingDetails = () => setIsBillingDetailsVisible(!isBillingDetailsVisible);
        const toggleCalculation = () => setIsCalculationVisible(!isCalculationVisible);

        useEffect(() => {
            const initializeForm = async () => {
                form.setFieldsValue({ status: "Draft" });
                if (userData?.kode_grup1) {
                    form.setFieldsValue({ service_advisor: userData.kode_grup1 });
                    setServiceAdvisorName(userData.nama || "");
                }

                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/current-date`);
                    const currentDate = response.data.currentDate;
                    form.setFieldsValue({ work_estimation_date: currentDate });
                } catch (error) {
                    console.error("Failed to fetch current date:", error);
                    const clientDate = dayjs().format("DD/MM/YYYY");
                    form.setFieldsValue({ work_estimation_date: clientDate });
                }
            };
            if (!weNoFromState) {
                initializeForm();
            }
        }, [form, userData, weNoFromState]);

        useEffect(() => {
            if (existingWorkOrderData) {
                const main = existingWorkOrderData.main;
                const descriptions = existingWorkOrderData.descriptions;
                const remarks = existingWorkOrderData.remarks;
                const calculations = existingWorkOrderData.calculations;
                if (main?.work_estimation_no) sessionStorage.setItem("active_weNo", main.work_estimation_no);
                const displayStatus = getStatusLabel(main.status);

                form.setFieldsValue({
                    status: displayStatus,
                    service_advisor: main.service_advisor,
                    work_estimation_no: main.work_estimation_no,
                    work_estimation_date: main.work_estimation_date
                        ? dayjs(main.work_estimation_date).format("DD/MM/YYYY")
                        : null,
                    work_order_no: main.work_order_no,
                    work_order_date: formatDateStringToDMY(main.work_order_date),
                    brand: main.brand,
                    model: main.model,
                    service_site: main.service_site,
                    warehouse: main.warehouse,
                    chassis_no: main.chassis_no,
                    no_polisi: main.no_polisi,
                    bill_to_code: main.bill_to_code,
                    bill_to_name: main.bill_to_name,
                    arrival_time: main.arrival_time && dayjs(main.arrival_time).isValid() ? dayjs(main.arrival_time) : null,
                    current_milage: main.current_milage,
                    current_message: main.current_message,
                    remark_outstanding: main.remark_outstanding,
                    reason: main.reason,
                    approval_remark: main.approval_remark,
                    name_contact: main.name_contact,
                    phone_contact: main.phone_contact,
                    policy: main.policy,
                    expired_date: main.expired_date,
                    claim_no: main.claim_no,

                    name_detail: main.name_detail,
                    no_id_detail: main.no_id_detail,
                    address_detail: main.address_detail,
                    provinsi_detail: main.provinsi_detail_label,
                    kabupaten_detail: main.kabupaten_detail_label,
                    kecamatan_detail: main.kecamatan_detail_label,
                    kelurahan_detail: main.kelurahan_detail_label,
                    kode_pos_detail: main.kode_pos_detail,
                    phone_number_detail: main.phone_number_detail,

                    stnk_name: main.stnk_name,
                    stnk_address: main.stnk_address,
                    provinsi_stnk: main.provinsi_stnk_label,
                    kabupaten_stnk: main.kabupaten_stnk_label,
                    kecamatan_stnk: main.kecamatan_stnk_label,
                    kelurahan_stnk: main.kelurahan_stnk_label,
                    kode_pos_stnk: main.kode_pos_stnk,

                    engine_no_detail: main.engine_no_detail,
                    brand_detail: main.brand_detail_label,
                    model_detail: main.model_detail_label,
                    last_service_detail: main.last_service_detail,
                    last_miliage_detail: main.last_miliage_detail,

                    name_billing: main.name_billing,
                    address_billing: main.address_billing,
                    provinsi_billing: main.provinsi_billing_label,
                    kabupaten_billing: main.kabupaten_billing_label,
                    kecamatan_billing: main.kecamatan_billing_label,
                    kelurahan_billing: main.kelurahan_billing_label,
                    kode_pos_billing: main.kode_pos_billing,

                    estimated_duration: main.estimated_duration ? dayjs(main.estimated_duration, "HH:mm") : null,
                    notes: main.notes,
                    recommendation: main.recommendation,
                    down_payment: main.down_payment,
                    credit_limit_remaining: main.credit_limit_remaining,
                });

                if (main.service_advisor) {
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/user-by-kode-grup1/${main.service_advisor}`)
                        .then((res) => {
                            setServiceAdvisorName(res.data.nama || main.service_advisor);
                        })
                        .catch(() => {
                            setServiceAdvisorName(main.service_advisor);
                        });
                }

                setDescriptionDataSource(descriptions);
                setDescriptionCount(descriptions.length > 0 ? (descriptions[descriptions.length - 1].key as number) + 1 : 0);
                setRemarkDataSource(remarks);
                setRemarkCount(remarks.length > 0 ? (remarks[remarks.length - 1].key as number) + 1 : 0);
                const formattedCalculations = calculations.map((row: any, index: number) => ({
                    key: index,
                    no: Number(row.no),
                    status: row.status,
                    type: row.type,
                    trxType: row.trxType,
                    jobType: row.jobType,
                    number: row.number,
                    description: row.description,
                    uom: row.uom,
                    frtQty: Number(row.frtQty),
                    supplyQty: row.supplyQty,
                    price: Number(row.price),
                    originalDisc: Number(row.originalDisc),
                    originalDiscAmount: Number(row.originalDiscAmount),
                    proposalDisc: Number(row.proposalDisc),
                    proposalDiscAmount: Number(row.proposalDiscAmount),
                    total: Number(row.total),
                    warehouse: row.warehouse,
                    hpp: Number(row.hpp || 0),
                    stockQty: row.stockQty,
                }));
                setCalculationDataSource(sortAndRecalculateNo(formattedCalculations));
                setCalculationCount(calculations.length > 0 ? (calculations[calculations.length - 1].key as number) + 1 : 0);
                latestCalculationsRef.current = {
                    sub_total: Number(main.sub_total || 0),
                    discount: Number(main.discount || 0),
                    total: Number(main.total || 0),
                    vat: Number(main.vat || 0),
                    grand_total: Number(main.grand_total || 0),
                };

                const newCodes = {
                    brand: main.brand,
                    model: main.model,
                    warehouse: main.warehouse,
                    provinsi_detail: main.provinsi_detail,
                    kabupaten_detail: main.kabupaten_detail,
                    kecamatan_detail: main.kecamatan_detail,
                    kelurahan_detail: main.kelurahan_detail,
                    provinsi_stnk: main.provinsi_stnk,
                    kabupaten_stnk: main.kabupaten_stnk,
                    kecamatan_stnk: main.kecamatan_stnk,
                    kelurahan_stnk: main.kelurahan_stnk,
                    provinsi_billing: main.provinsi_billing,
                    kabupaten_billing: main.kabupaten_billing,
                    kecamatan_billing: main.kecamatan_billing,
                    kelurahan_billing: main.kelurahan_billing,
                    brand_detail: main.brand_detail,
                    model_detail: main.model_detail,
                };
                setCodes(newCodes);

                const loadedStatus = main.status;
                if (
                    loadedStatus !== "1" &&
                    loadedStatus !== "Draft" &&
                    loadedStatus !== "2" &&
                    loadedStatus !== "New" &&
                    loadedStatus !== "7" &&
                    loadedStatus !== "On Going"
                ) {
                    setAutosaveStatus("stopped");
                } else {
                    setAutosaveStatus("idle");
                }

                previousDataRef.current = {
                    formValues: form.getFieldsValue(true),
                    descriptions: descriptions,
                    remarks: remarks,
                    calculations: formattedCalculations,
                    codes: newCodes,
                };
            }
        }, [existingWorkOrderData, form]);

        const generateWorkEstimationNo = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/generate-we-no`);
                return response.data.workEstimationNo;
            } catch (error) {
                console.error("Failed to generate Work Estimation No:", error);
                return null;
            }
        };

        const handleChassisSelect = async (record: Partial<ChassisDataType>) => {
            const weNo = await generateWorkEstimationNo();
            if (weNo) sessionStorage.setItem("active_weNo", weNo);
            form.setFieldsValue({
                chassis_no: record.chassisNo,
                no_polisi: record.noPol,
                engine_no_detail: record.engineNo,
                brand_detail: record.brand,
                model_detail: record.model,
                last_service_detail:
                    record.lastService && dayjs(record.lastService).isValid()
                        ? dayjs(record.lastService).format("DD/MM/YYYY")
                        : record.lastService,
                last_miliage_detail: record.lastKM,
                stnk_name: record.stnkName,
                stnk_address: record.stnkAddress,
                provinsi_stnk: record.provinsiStnk,
                kabupaten_stnk: record.kabupatenStnk,
                kecamatan_stnk: record.kecamatanStnk,
                kelurahan_stnk: record.kelurahanStnk,
                kode_pos_stnk: (record as ChassisDataType).kodePosStnk,
                name_detail: record.nameDetail,
                no_id_detail: record.noIdCurrentUser,
                address_detail: record.addressCurrentUser,
                provinsi_detail: record.provinsiCurrentUser,
                kabupaten_detail: record.kabupatenCurrentUser,
                kecamatan_detail: record.kecamatanCurrentUser,
                kelurahan_detail: record.kelurahanCurrentUser,
                kode_pos_detail: record.kodePosCurrentUser,
                phone_number_detail: record.phoneNumberCurrentUser,
                bill_to_code: record.noIdBilling,
                bill_to_name: record.customerNameBilling,
                name_billing: record.customerNameBilling,
                address_billing: record.addressCurrentUser,
                provinsi_billing: record.provinsiCurrentUser,
                kabupaten_billing: record.kabupatenCurrentUser,
                kecamatan_billing: record.kecamatanCurrentUser,
                kelurahan_billing: record.kelurahanCurrentUser,
                kode_pos_billing: record.kodePosCurrentUser,
                work_estimation_no: weNo,
            });
            setCodes((prev) => ({
                ...prev,
                brand_detail: record.brandCode,
                model_detail: record.modelCode,
                provinsi_stnk: record.provinsiStnkCode,
                kabupaten_stnk: record.kabupatenStnkCode,
                kecamatan_stnk: record.kecamatanStnkCode,
                kelurahan_stnk: record.kelurahanStnkCode,
                provinsi_detail: record.provinsiCurrentUserCode,
                kabupaten_detail: record.kabupatenCurrentUserCode,
                kecamatan_detail: record.kecamatanCurrentUserCode,
                kelurahan_detail: record.kelurahanCurrentUserCode,
                provinsi_billing: record.provinsiCurrentUserCode,
                kabupaten_billing: record.kabupatenCurrentUserCode,
                kecamatan_billing: record.kecamatanCurrentUserCode,
                kelurahan_billing: record.kelurahanCurrentUserCode,
            }));
            handleChassisCancel();
        };

        const handleBillingSelect = (record: Partial<BillingDataType>) => {
            form.setFieldsValue({
                bill_to_code: record.customerCode,
                bill_to_name: record.customerName,
                name_billing: record.customerName,
                address_billing: `${record.address1 || ""} - ${record.address2 || ""}`,
                provinsi_billing: record.provinsi,
                kabupaten_billing: record.kabupaten,
                kecamatan_billing: record.kecamatan,
                kelurahan_billing: record.kelurahan,
                kode_pos_billing: record.kodePos,
            });
            setCodes((prev) => ({
                ...prev,
                provinsi_billing: record.provinsiCode,
                kabupaten_billing: record.kabupatenCode,
                kecamatan_billing: record.kecamatanCode,
                kelurahan_billing: record.kelurahanCode,
            }));
            handleCancel();
        };

        const handleAutosave = useRef(
            debounce(
                async (
                    currentFormValues: any,
                    descriptionData: DataType[],
                    remarkData: RemarkDataType[],
                    calculationData: CalculationDataType[],
                    currentCodes: { [key: string]: string | number | undefined },
                ) => {
                    const chassisNo = currentFormValues?.chassis_no;
                    const weNo = currentFormValues?.work_estimation_no;

                    if (!chassisNo || !weNo) {
                        setAutosaveStatus("stopped");
                        return;
                    }

                    let statusForPayload = currentFormValues.status;
                    if (statusForPayload === "Draft" || statusForPayload === "1") {
                        statusForPayload = "1";
                    } else if (statusForPayload === "New" || statusForPayload === "2") {
                        statusForPayload = "2";
                    } else if (statusForPayload === "On Going" || statusForPayload === "7") {
                        statusForPayload = "7";
                    } else if (statusForPayload === "Waiting for Approved" || statusForPayload === "3") {
                        statusForPayload = "3";
                    } else if (statusForPayload === "Billing Preparation" || statusForPayload === "9") {
                        statusForPayload = "9";
                    }

                    try {
                        const payload = {
                            status: statusForPayload,
                            service_advisor: currentFormValues.service_advisor,
                            work_estimation_no: weNo,
                            work_estimation_date: currentFormValues.work_estimation_date,
                            work_order_no: currentFormValues.work_order_no,
                            work_order_date: currentFormValues.work_order_date,
                            brand: currentFormValues.brand,
                            model: currentFormValues.model,
                            service_site: currentFormValues.service_site,
                            warehouse: currentFormValues.warehouse,
                            chassis_no: chassisNo,
                            no_polisi: currentFormValues.no_polisi,
                            bill_to_code: currentFormValues.bill_to_code,
                            bill_to_name: currentFormValues.bill_to_name,
                            arrival_time: currentFormValues.arrival_time,
                            current_milage: currentFormValues.current_milage,
                            current_message: currentFormValues.current_message,
                            remark_outstanding: currentFormValues.remark_outstanding,
                            reason: currentFormValues.reason,
                            approval_remark: currentFormValues.approval_remark,
                            name_contact: currentFormValues.name_contact,
                            phone_contact: currentFormValues.phone_contact,
                            policy: currentFormValues.policy,
                            expired_date: currentFormValues.expired_date,
                            claim_no: currentFormValues.claim_no,

                            name_detail: currentFormValues.name_detail,
                            no_id_detail: currentFormValues.no_id_detail,
                            address_detail: currentFormValues.address_detail,
                            provinsi_detail: currentCodes.provinsi_detail || currentFormValues.provinsi_detail,
                            kabupaten_detail: currentCodes.kabupaten_detail || currentFormValues.kabupaten_detail,
                            kecamatan_detail: currentCodes.kecamatan_detail || currentFormValues.kecamatan_detail,
                            kelurahan_detail: currentCodes.kelurahan_detail || currentFormValues.kelurahan_detail,
                            kode_pos_detail: currentFormValues.kode_pos_detail,
                            phone_number_detail: currentFormValues.phone_number_detail,

                            stnk_name: currentFormValues.stnk_name,
                            stnk_address: currentFormValues.stnk_address,
                            provinsi_stnk: currentCodes.provinsi_stnk || currentFormValues.provinsi_stnk,
                            kabupaten_stnk: currentCodes.kabupaten_stnk || currentFormValues.kabupaten_stnk,
                            kecamatan_stnk: currentCodes.kecamatan_stnk || currentFormValues.kecamatan_stnk,
                            kelurahan_stnk: currentCodes.kelurahan_stnk || currentFormValues.kelurahan_stnk,
                            kode_pos_stnk: currentFormValues.kode_pos_stnk,

                            engine_no_detail: currentFormValues.engine_no_detail,
                            brand_detail: currentCodes.brand_detail,
                            model_detail: currentCodes.model_detail,
                            last_service_detail: currentFormValues.last_service_detail,
                            last_miliage_detail: currentFormValues.last_miliage_detail,

                            name_billing: currentFormValues.name_billing,
                            address_billing: currentFormValues.address_billing,
                            provinsi_billing: currentCodes.provinsi_billing || currentFormValues.provinsi_billing,
                            kabupaten_billing: currentCodes.kabupaten_billing || currentFormValues.kabupaten_billing,
                            kecamatan_billing: currentCodes.kecamatan_billing || currentFormValues.kecamatan_billing,
                            kelurahan_billing: currentCodes.kelurahan_billing || currentFormValues.kelurahan_billing,
                            kode_pos_billing: currentFormValues.kode_pos_billing,

                            estimated_duration: currentFormValues.estimated_duration
                                ? dayjs(currentFormValues.estimated_duration).format("HH:mm")
                                : null,
                            notes: currentFormValues.notes,
                            recommendation: currentFormValues.recommendation,
                            down_payment: currentFormValues.down_payment,
                            credit_limit_remaining: currentFormValues.credit_limit_remaining,

                            sub_total: latestCalculationsRef.current.sub_total,
                            discount: latestCalculationsRef.current.discount,
                            total: latestCalculationsRef.current.total,
                            vat: latestCalculationsRef.current.vat,
                            grand_total: latestCalculationsRef.current.grand_total,

                            request_descriptions: descriptionData.map((d) => ({ request: d.description })),
                            vehicle_remarks: remarkData.map((r) => ({ remark_date: r.remarkDate, remark: r.remark })),
                            calculation_items: calculationData.map((c) => ({
                                type: c.type,
                                trx_type: c.trxType,
                                job_type: c.jobType,
                                item_code: c.number,
                                item_name: c.description,
                                uom: c.uom,
                                qty: c.frtQty,
                                supply_qty: c.supplyQty,
                                price: c.price,
                                disc_percent: c.proposalDisc,
                                disc_amount: c.proposalDiscAmount,
                                total: c.total,
                                warehouse: c.warehouse,
                                hpp: c.hpp,
                            })),
                        };

                        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/autosave`, payload);
                        setAutosaveStatus("idle");
                    } catch (error) {
                        console.error("Autosave failed:", error);
                        setAutosaveStatus("error");
                    }
                },
                500,
            ),
        ).current;

        const handleFormChange = (changedValues: any, allValues: any) => {
            const chassisNo = allValues.chassis_no || form.getFieldValue("chassis_no");
            const weNo = allValues.work_estimation_no || form.getFieldValue("work_estimation_no");
            const currentStatus = form.getFieldValue("status");

            if (
                chassisNo &&
                weNo &&
                (currentStatus === "Draft" ||
                    currentStatus === "1" ||
                    currentStatus === "Billing Preparation" ||
                    currentStatus === "9" ||
                    currentStatus === "New" ||
                    currentStatus === "2" ||
                    currentStatus === "On Going" ||
                    currentStatus === "7")
            ) {
                setAutosaveStatus("processing");
                handleAutosave(allValues, descriptionDataSource, remarkDataSource, calculationDataSource, codes);
            } else {
                setAutosaveStatus("stopped");
            }
        };

        useEffect(() => {
            if (warehousesData && warehousesData.length === 1) {
                const currentVal = form.getFieldValue("warehouse");
                const singleVal = warehousesData[0].value;
                if (currentVal !== singleVal) {
                    form.setFieldsValue({ warehouse: singleVal });
                    handleFormChange({ warehouse: singleVal }, { ...form.getFieldsValue(true), warehouse: singleVal });
                }
            }
        }, [warehousesData, form]);

        useEffect(() => {
            const chassisNo = form.getFieldValue("chassis_no");
            const weNo = form.getFieldValue("work_estimation_no");
            const currentStatus = form.getFieldValue("status");

            const currentData = {
                formValues: form.getFieldsValue(true),
                descriptions: descriptionDataSource,
                remarks: remarkDataSource,
                calculations: calculationDataSource,
                codes: codes,
            };
            if (previousDataRef.current && isEqual(previousDataRef.current, currentData)) {
                return;
            }

            if (!previousDataRef.current) {
                previousDataRef.current = currentData;
                return;
            }

            previousDataRef.current = currentData;

            if (
                chassisNo &&
                weNo &&
                (currentStatus === "Draft" ||
                    currentStatus === "1" ||
                    currentStatus === "Billing Preparation" ||
                    currentStatus === "9" ||
                    currentStatus === "New" ||
                    currentStatus === "2" ||
                    currentStatus === "On Going" ||
                    currentStatus === "7")
            ) {
                setAutosaveStatus("processing");
                handleAutosave(form.getFieldsValue(), descriptionDataSource, remarkDataSource, calculationDataSource, codes);
            } else {
                setAutosaveStatus("stopped");
            }

            return () => {
                handleAutosave.cancel();
            };
        }, [descriptionDataSource, remarkDataSource, calculationDataSource, handleAutosave, codes, form]);

        const onFormValuesChange = useCallback((changedValues: any, allValues: any) => {
            handleFormChange(changedValues, allValues);
            if (socket && currentWeNo) {
                socket.emit("wo_sync_field_data", {
                    weNo: currentWeNo,
                    changedValues,
                    allValues,
                    descriptions: descriptionDataSource,
                    remarks: remarkDataSource,
                    calculations: calculationDataSource
                });
            }
        }, [socket, currentWeNo, handleFormChange, descriptionDataSource, remarkDataSource, calculationDataSource]);

        const handleSubmitWorkOrder = async () => {
            try {
                await form.validateFields();

                const weNo = form.getFieldValue("work_estimation_no");
                if (!weNo) {
                    notification.warning({
                        message: "Peringatan",
                        description: "Lengkapi data terlebih dahulu sebelum Submit.",
                        placement: "topRight",
                    });
                    return;
                }

                const currentStatus = form.getFieldValue("status");
                if (currentStatus === "9" || currentStatus === "Billing Preparation") {
                    Modal.confirm({
                        title: "Konfirmasi Submit",
                        content: "Apakah data sudah benar? proses ini akan menjadikan \"QC Pass\" kembali",
                        okText: "Ya",
                        cancelText: "Batal",
                        okButtonProps: { style: { backgroundColor: "#52c41a", borderColor: "#52c41a" } },
                        onOk: async () => {
                            setAutosaveStatus("processing");
                            try {
                                form.setFieldsValue({ status: "QC Pass" });
                                await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/submit-billing-prep`, {
                                    workEstimationNo: weNo,
                                });
                                notification.success({
                                    message: "Berhasil",
                                    description: `Work Order Estimation No. ${weNo} berhasil disubmit menjadi QC Pass.`,
                                    placement: "topRight",
                                });
                                setAutosaveStatus("stopped");
                            } catch (error) {
                                console.error("Failed to submit billing preparation:", error);
                                notification.error({
                                    message: "Gagal",
                                    description: `Gagal mensubmit Billing Preparation.`,
                                    placement: "topRight",
                                });
                                setAutosaveStatus("error");
                            }
                        }
                    });
                    return;
                }

                let submitRemark = "";
                Modal.confirm({
                    title: "Konfirmasi Submit",
                    content: (
                        <div>
                            <p>Apakah data sudah benar? Silakan masukkan remark:</p>
                            <Input.TextArea
                                rows={3}
                                placeholder="Masukkan remark di sini..."
                                onChange={(e) => {
                                    submitRemark = e.target.value;
                                }}
                            />
                        </div>
                    ),
                    okText: "Ya",
                    cancelText: "Batal",
                    okButtonProps: { style: { backgroundColor: "#52c41a", borderColor: "#52c41a" } },
                    onOk: async () => {
                        setAutosaveStatus("processing");
                        try {
                            form.setFieldsValue({ status: "Waiting for Approved" });
                            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/submit`, {
                                workEstimationNo: weNo,
                                remark: submitRemark,
                            });

                            notification.success({
                                message: "Berhasil",
                                description: `Work Order Estimation No. ${weNo} berhasil disubmit.`,
                                placement: "topRight",
                            });

                            console.log("Work Order submitted successfully and status updated.");
                            setAutosaveStatus("stopped");
                        } catch (error) {
                            console.error("Failed to submit Work Order and update status:", error);
                            notification.error({
                                message: "Gagal",
                                description: `Gagal submit Work Order Estimation No. ${weNo}.`,
                                placement: "topRight",
                            });
                            setAutosaveStatus("error");
                        }
                    },
                    onCancel() {
                        console.log("Submit dibatalkan.");
                        setAutosaveStatus("idle");
                    },
                });
            } catch (errorInfo) {
                console.log("Failed to validate form:", errorInfo);
                notification.warning({
                    message: "Peringatan",
                    description: "Lengkapi data terlebih dahulu sebelum Submit.",
                    placement: "topRight",
                });
            }
        };

        const handleCloseOrder = async () => {
            try {
                await form.validateFields();
                const weNo = form.getFieldValue("work_estimation_no");
                if (!weNo) {
                    notification.warning({
                        message: "Peringatan",
                        description: "Lengkapi data terlebih dahulu sebelum Close Order.",
                        placement: "topRight",
                    });
                    return;
                }
                let closeOrderRemark = "Close Order";
                Modal.confirm({
                    title: "Konfirmasi Close Order",
                    content: (
                        <CloseOrderModalContent
                            onChange={(val) => {
                                closeOrderRemark = val;
                            }}
                        />
                    ),
                    okText: "Ya",
                    cancelText: "Batal",
                    okButtonProps: { style: { backgroundColor: "#ff4d4f", borderColor: "#ff4d4f" } },
                    onOk: async () => {
                        setAutosaveStatus("processing");
                        try {
                            form.setFieldsValue({ status: "Waiting for Approved" });
                            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/submit`, {
                                workEstimationNo: weNo,
                                remark: closeOrderRemark,
                                wo_close_order: 1,
                            });
                            notification.success({
                                message: "Berhasil",
                                description: `Work Order Estimation No. ${weNo} berhasil di Close Order.`,
                                placement: "topRight",
                            });
                            setAutosaveStatus("stopped");
                        } catch (error) {
                            console.error("Failed to Close Order:", error);
                            notification.error({
                                message: "Gagal",
                                description: `Gagal Close Order Work Order Estimation No. ${weNo}.`,
                                placement: "topRight",
                            });
                            setAutosaveStatus("error");
                        }
                    },
                    onCancel() {
                        console.log("Close Order dibatalkan.");
                    },
                });
            } catch (errorInfo) {
                console.log("Failed to validate form:", errorInfo);
                notification.warning({
                    message: "Peringatan",
                    description: "Lengkapi data terlebih dahulu sebelum Close Order.",
                    placement: "topRight",
                });
            }
        };

        const handleVoidWorkOrder = async () => {
            const weNo = form.getFieldValue("work_estimation_no");

            if (!weNo) {
                notification.warning({
                    message: "Peringatan",
                    description: "Tidak ada Work Estimation No. untuk dibatalkan.",
                    placement: "topRight",
                });
                return;
            }

            Modal.confirm({
                title: "Konfirmasi Pembatalan Work Order",
                content: `Apakah Anda yakin ingin menghapus Work Order Estimation No. ${weNo} beserta semua data terkaitnya? Tindakan ini tidak dapat dibatalkan.`,
                okText: "Ya, Hapus",
                okButtonProps: { danger: true },
                cancelText: "Batal",
                onOk: async () => {
                    setAutosaveStatus("processing");
                    try {
                        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/void`, {
                            workEstimationNo: weNo,
                        });

                        notification.success({
                            message: "Berhasil",
                            description: `Work Order Estimation No. ${weNo} berhasil dihapus.`,
                            placement: "topRight",
                        });

                        form.resetFields();
                        setDescriptionDataSource([]);
                        setRemarkDataSource([]);
                        setCalculationDataSource([]);
                        sessionStorage.removeItem("active_weNo");
                        setAutosaveStatus("stopped");
                        navigate("/dashboard/work_order", { replace: true });
                    } catch (error) {
                        console.error("Failed to void Work Order:", error);
                        notification.error({
                            message: "Gagal",
                            description: `Gagal menghapus Work Order Estimation No. ${weNo}.`,
                            placement: "topRight",
                        });
                        setAutosaveStatus("error");
                    }
                },
                onCancel() {
                    console.log("Pembatalan void dibatalkan.");
                },
            });
        };

        const handleReviseWorkOrder = async () => {
            const woNo = form.getFieldValue("work_order_no");
            if (!woNo) {
                notification.warning({
                    message: "Peringatan",
                    description: "Tidak ada Work Order No untuk direvisi.",
                    placement: "topRight",
                });
                return;
            }
            try {
                const checkResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/check-invoice/${encodeURIComponent(woNo)}`);
                if (checkResponse.data && checkResponse.data.exists) {
                    Modal.warning({
                        title: "Peringatan",
                        content: `Nomor ${woNo} sudah ada di data invoice harap hapus terlebih dahulu jika ingin revise !.`,
                    });
                    return;
                }
            } catch (error) {
                console.error("Failed to check work order invoice existence:", error);
                notification.error({
                    message: "Gagal Memeriksa Invoice",
                    description: "Terjadi kesalahan saat memeriksa data invoice.",
                    placement: "topRight",
                });
                return;
            }
            let reviseRemark = "Revise";
            Modal.confirm({
                title: "Konfirmasi Revisi",
                content: (
                    <ReviseOrderModalContent
                        onChange={(val) => {
                            reviseRemark = val;
                        }}
                    />
                ),
                okText: "Ya",
                cancelText: "Batal",
                okButtonProps: { style: { backgroundColor: "#fa8c16", borderColor: "#fa8c16" } },
                onOk: async () => {
                    setAutosaveStatus("processing");
                    try {
                        form.setFieldsValue({ status: "Waiting for Approved" });
                        const localDate = new Date();
                        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/revise-request`, {
                            work_order_no: woNo,
                            remark: reviseRemark,
                            request_by: userData?.kode_grup1 || "",
                            warehouse: form.getFieldValue("warehouse") || "",
                            amount: latestCalculationsRef.current.grand_total || 0,
                            date_request: localDate
                        });
                        notification.success({
                            message: "Berhasil",
                            description: `Revisi untuk Work Order No. ${woNo} berhasil diajukan.`,
                            placement: "topRight",
                        });
                        setAutosaveStatus("stopped");
                    } catch (error) {
                        console.error("Failed to request revise:", error);
                        notification.error({
                            message: "Gagal",
                            description: `Gagal mengajukan revisi Work Order No. ${woNo}.`,
                            placement: "topRight",
                        });
                        setAutosaveStatus("error");
                    }
                },
                onCancel() {
                    console.log("Revisi dibatalkan.");
                },
            });
        };

        const handlePrintWorkOrder = async () => {
            const weNo = form.getFieldValue("work_estimation_no");
            if (!weNo) {
                notification.warning({ message: "Nomor Work Estimation tidak ditemukan untuk dicetak." });
                return;
            }
            setIsPrinting(true);
            try {
                const dataResponse = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/work-order/${encodeURIComponent(weNo)}`,
                );
                const { main, descriptions, remarks, calculations, mechanic } = dataResponse.data;
                if (!mechanic || mechanic === "-" || mechanic.trim() === "") {
                    notification.warning({
                        message: "Peringatan",
                        description: "Alokasi mekanik masih kosong, disarankan alokasi terlebih dahulu !",
                        placement: "topRight",
                    });
                }
                if (!main) {
                    notification.error({ message: "Data header Work Order tidak ditemukan." });
                    return;
                }
                const reportPayload = {
                    Header: [{
                        work_estimation_no: main.work_estimation_no || "",
                        work_estimation_date: main.work_estimation_date || "",
                        work_order_no: main.work_order_no || "",
                        work_order_date: main.work_order_date || "",
                        status: main.status || "",
                        document_title: main.status === "1" ? "ESTIMASI BIAYA" : "WORK ORDER",
                        warehouse: main.warehouse_label || main.warehouse || "",
                        warehouse_address: main.warehouse_address || "",
                        warehouse_contact_person: main.warehouse_contact_person || "",
                        dealer_name: main.dealer_name || "",
                        service_site: main.service_site || "",
                        service_advisor: serviceAdvisorName || main.service_advisor || "",
                        mechanic: mechanic || "",
                        chassis_no: main.chassis_no || "",
                        no_polisi: main.no_polisi || "",
                        engine_no_detail: main.engine_no_detail || "",
                        brand: main.brand_detail_label || main.brand_label || "",
                        model: main.model_detail_label || main.model_label || "",
                        current_milage: main.current_milage || "",
                        arrival_time: main.arrival_time ? dayjs(main.arrival_time).format("DD/MM/YYYY HH:mm") : "",
                        estimated_duration: main.estimated_duration ? dayjs(main.estimated_duration, "HH:mm").format("HH:mm") : "",
                        last_service_detail: main.last_service_detail || "",
                        name_detail: main.name_detail || "",
                        address_detail: main.address_detail || "",
                        phone_number_detail: main.phone_number_detail || "",
                        stnk_name: main.stnk_name || "",
                        stnk_address: main.stnk_address || "",
                        bill_to_code: main.bill_to_code || "",
                        bill_to_name: main.name_billing || main.bill_to_name || "",
                        address_billing: main.address_billing || "",
                        notes: main.notes || "",
                        recommendation: main.recommendation || "",
                        sub_total: Number(main.sub_total) || 0,
                        discount: Number(main.discount) || 0,
                        total: Number(main.total) || 0,
                        vat: Number(main.vat) || 0,
                        grand_total: Number(main.grand_total) || 0,
                        total_biaya_jasa: (calculations || []).filter((c: any) => String(c.type) === "4").reduce((sum: number, c: any) => sum + (Number(c.total) || 0), 0),
                        total_biaya_spareparts: (calculations || []).filter((c: any) => String(c.type) !== "4").reduce((sum: number, c: any) => sum + (Number(c.total) || 0), 0),
                        _subtotal: Number(main.total) || 0,
                        _ppn: Number(main.vat) || 0,
                        _total: Number(main.grand_total) || 0
                    }],
                    Descriptions: (descriptions || []).map((d: any, idx: number) => ({
                        row_no: idx + 1,
                        description: d.description || ""
                    })),
                    Remarks: (remarks || []).map((r: any, idx: number) => ({
                        row_no: idx + 1,
                        remark_date: r.remarkDate || "",
                        remark: r.remark || ""
                    })),
                    DetailsJasa: (calculations || [])
                        .filter((c: any) => String(c.type) === "4")
                        .map((c: any, idx: number) => ({
                            row_no: idx + 1,
                            job_type: c.jobType || "",
                            item_code: c.number || "",
                            item_name: c.description || "",
                            frt_qty: Number(c.frtQty) || 0,
                            price: Number(c.price) || 0,
                            disc_percent: Number(c.proposalDisc) || 0,
                            discount: Number(c.proposalDiscAmount) || 0,
                            total: Number(c.total) || 0
                        })),
                    DetailsSparepart: (calculations || [])
                        .filter((c: any) => String(c.type) !== "4")
                        .map((c: any, idx: number) => ({
                            row_no: idx + 1,
                            job_type: c.jobType || "",
                            item_code: c.number || "",
                            item_name: c.description || "",
                            qty: Number(c.frtQty) || 0,
                            price: Number(c.price) || 0,
                            disc_percent: Number(c.proposalDisc) || 0,
                            discount: Number(c.proposalDiscAmount) || 0,
                            total: Number(c.total) || 0,
                            stocks: (parseFloat(c.stockQty) >= parseFloat(c.frtQty)) ? "Ready" : "0"
                        }))
                };
                await import("stimulsoft-reports-js/Css/stimulsoft.viewer.office2013.whiteblue.css");
                await import("stimulsoft-reports-js/Scripts/stimulsoft.reports");
                const viewerModule = await import("stimulsoft-reports-js/Scripts/stimulsoft.viewer");
                const Stimulsoft = viewerModule.Stimulsoft || (window as any).Stimulsoft;
                StartLicense(Stimulsoft);
                setIsReportModalOpen(true);
                setTimeout(() => {
                    const report = Stimulsoft.Report.StiReport.createNewReport();
                    report.loadFile("/reports/WO/wo.mrt");
                    const dataSet = new Stimulsoft.System.Data.DataSet("ReportData");
                    dataSet.readJson(reportPayload);
                    report.regData(dataSet.dataSetName, "", dataSet);
                    report.dictionary.synchronize();
                    const options = new Stimulsoft.Viewer.StiViewerOptions();
                    options.toolbar.showOpenButton = true;
                    const viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
                    (viewer as any).onOpenReport = (args: any) => {
                        const newReport = args.report;
                        if (newReport) {
                            newReport.regData(dataSet.dataSetName, "", dataSet);
                            newReport.dictionary.synchronize();
                            viewer.report = newReport;
                        }
                    };
                    viewer.report = report;
                    viewer.renderHtml("sti-viewer-container");
                }, 300);
            } catch (error) {
                console.error("Gagal mencetak Work Order:", error);
                notification.error({
                    message: "Gagal mencetak Work Order. Terjadi kesalahan saat mengambil data atau template.",
                });
            } finally {
                setIsPrinting(false);
            }
        };

        const handleNew = async () => {
            form.resetFields();
            setDescriptionDataSource([]);
            setRemarkDataSource([]);
            setCalculationDataSource([]);
            setCodes({});
            setAutosaveStatus("stopped");
            sessionStorage.removeItem("active_weNo");
            form.setFieldsValue({ status: "Draft" });
            if (userData?.kode_grup1) {
                form.setFieldsValue({ service_advisor: userData.kode_grup1 });
                setServiceAdvisorName(userData.nama || "");
            }
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/current-date`);
                const currentDate = response.data.currentDate;
                form.setFieldsValue({ work_estimation_date: currentDate });
            } catch (error) {
                const clientDate = dayjs().format("DD/MM/YYYY");
                form.setFieldsValue({ work_estimation_date: clientDate });
            }
            notification.success({ message: "Reset Form Berhasil", placement: "topRight" });
        };

        const handleRefreshCalculations = async () => {
            const currentFormValues = form.getFieldsValue(true);
            const weNo = currentFormValues.work_estimation_no;
            if (!weNo) {
                notification.warning({
                    message: "Peringatan",
                    description: "Work Estimation No belum di-generate.",
                    placement: "topRight"
                });
                return;
            }
            form.setFieldsValue({
                sub_total: calculatedSubTotal,
                discount: calculatedDiscount,
                total: calculatedTotal,
                vat: calculatedVat,
                grand_total: calculatedGrandTotal,
            });
            setAutosaveStatus("processing");
            try {
                let statusForPayload = currentFormValues.status;
                if (statusForPayload === "Draft" || statusForPayload === "1") {
                    statusForPayload = "1";
                } else if (statusForPayload === "New" || statusForPayload === "2") {
                    statusForPayload = "2";
                } else if (statusForPayload === "On Going" || statusForPayload === "7") {
                    statusForPayload = "7";
                } else if (statusForPayload === "Waiting for Approved" || statusForPayload === "3") {
                    statusForPayload = "3";
                } else if (statusForPayload === "Billing Preparation" || statusForPayload === "9") {
                    statusForPayload = "9";
                }
                const payload = {
                    ...currentFormValues,
                    status: statusForPayload,
                    sub_total: calculatedSubTotal,
                    discount: calculatedDiscount,
                    total: calculatedTotal,
                    vat: calculatedVat,
                    grand_total: calculatedGrandTotal,
                    request_descriptions: descriptionDataSource.map((d) => ({ request: d.description })),
                    vehicle_remarks: remarkDataSource.map((r) => ({ remark_date: r.remarkDate, remark: r.remark })),
                    calculation_items: calculationDataSource.map((c) => ({
                        type: c.type,
                        trx_type: c.trxType,
                        job_type: c.jobType,
                        item_code: c.number,
                        item_name: c.description,
                        uom: c.uom,
                        qty: c.frtQty,
                        supply_qty: c.supplyQty,
                        price: c.price,
                        disc_percent: c.proposalDisc,
                        disc_amount: c.proposalDiscAmount,
                        total: c.total,
                        warehouse: c.warehouse,
                        hpp: c.hpp,
                    })),
                };
                await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/autosave`, payload);
                notification.success({
                    message: "Refresh Berhasil",
                    description: "Kalkulasi diperbarui dan disimpan ke database.",
                    placement: "topRight"
                });
                setAutosaveStatus("idle");
            } catch (error) {
                console.error("Refresh save failed:", error);
                setAutosaveStatus("error");
                notification.error({
                    message: "Gagal Menyimpan",
                    description: "Gagal memperbarui kalkulasi ke database.",
                    placement: "topRight"
                });
            }
        };

        const logicProps: WithWorkOrderLogicProps = {
            descriptionDataSource,
            descriptionRowSelection,
            handleDescriptionDelete,
            handleDescriptionAdd,
            handleDescriptionSave,
            remarkDataSource,
            remarkRowSelection,
            handleRemarkDelete,
            handleRemarkAdd,
            handleRemarkSave,
            isModalOpen,
            showModal,
            handleOk,
            handleCancel,
            isChassisModalOpen,
            showChassisModal,
            handleChassisOk,
            handleChassisCancel,
            form,
            handleChassisSelect,
            handleBillingSelect,
            calculationDataSource,
            calculationColumns,
            calculationRowSelection,
            handleCalculationDelete,
            isAddEditModalOpen,
            showAddEditModal,
            handleAddEditOk,
            handleAddEditCancel,
            isCurrentUserDetailsVisible,
            toggleCurrentUserDetails,
            isVehicleDetailsVisible,
            toggleVehicleDetails,
            isStnkDetailsVisible,
            toggleStnkDetails,
            isBillingDetailsVisible,
            toggleBillingDetails,
            isCalculationVisible,
            toggleCalculation,
            addEditForm,
            handleCalculationSubmit: handleCalculationSubmit,
            handleCalculationEdit: handleCalculationEdit,
            editingRecord: editingRecord,
            brands: brandsData || [],
            models: modelsData || [],
            warehouses: warehousesData || [],
            autosaveStatus: autosaveStatus,
            handleFormChange,
            ppnValue: ppnValue,
            handleSubmitWorkOrder,
            handleVoidWorkOrder,
            handleCloseOrder,
            serviceAdvisorName: serviceAdvisorName,
            handlePrintWorkOrder: handlePrintWorkOrder,
            isPrinting: isPrinting,
            handleNew: handleNew,
            handleCalculationAddRow: handleCalculationAddRow,
            handleReviseWorkOrder: handleReviseWorkOrder,
            isReportModalOpen: isReportModalOpen,
            handleReportModalCancel: () => setIsReportModalOpen(false),
            handleRefreshCalculations: handleRefreshCalculations,
            lockedFields: lockedFields,
            onFieldFocus: onFieldFocus,
            onFieldBlur: onFieldBlur,
            onFormValuesChange: onFormValuesChange,
        };

        return <WrappedComponent {...(props as P)} {...logicProps} />;
    };

    return WorkOrderWithLogic;
};
